const config = {
    apiBaseUrl: process.env.VUE_APP_API_BASE_URL,
    webBaseUrl: process.env.VUE_APP_WEB_BASE_URL || 'http://localhost:8080',
  };
  
  export default config;
  